import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.is-array";
import _slicedToArray from "C:/Work/game-blog/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "C:/Work/game-blog/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.math.imul";
import _classCallCheck from "C:/Work/game-blog/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "C:/Work/game-blog/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e16) { throw _e16; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e17) { didErr = true; err = _e17; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var t = "http://www.w3.org/2000/svg";

var e = /*#__PURE__*/function () {
  function e(t) {
    _classCallCheck(this, e);

    this.seed = t;
  }

  _createClass(e, [{
    key: "next",
    value: function next() {
      return this.seed ? (Math.pow(2, 31) - 1 & (this.seed = Math.imul(48271, this.seed))) / Math.pow(2, 31) : Math.random();
    }
  }]);

  return e;
}();

function s(t, e, s, i, n) {
  return {
    type: "path",
    ops: c(t, e, s, i, n)
  };
}

function i(t, e, i) {
  var n = (t || []).length;

  if (n > 2) {
    var _s = [];

    for (var _e = 0; _e < n - 1; _e++) {
      _s.push.apply(_s, _toConsumableArray(c(t[_e][0], t[_e][1], t[_e + 1][0], t[_e + 1][1], i)));
    }

    return e && _s.push.apply(_s, _toConsumableArray(c(t[n - 1][0], t[n - 1][1], t[0][0], t[0][1], i))), {
      type: "path",
      ops: _s
    };
  }

  return 2 === n ? s(t[0][0], t[0][1], t[1][0], t[1][1], i) : {
    type: "path",
    ops: []
  };
}

function n(t, e, s, n, o) {
  return function (t, e) {
    return i(t, !0, e);
  }([[t, e], [t + s, e], [t + s, e + n], [t, e + n]], o);
}

function o(t, e, s, i, n) {
  return function (t, e, s, i) {
    var _l = l(i.increment, t, e, i.rx, i.ry, 1, i.increment * h(.1, h(.4, 1, s), s), s),
        _l2 = _slicedToArray(_l, 2),
        n = _l2[0],
        o = _l2[1];

    var r = f(n, null, s);

    if (!s.disableMultiStroke) {
      var _l3 = l(i.increment, t, e, i.rx, i.ry, 1.5, 0, s),
          _l4 = _slicedToArray(_l3, 1),
          _n = _l4[0],
          _o = f(_n, null, s);

      r = r.concat(_o);
    }

    return {
      estimatedPoints: o,
      opset: {
        type: "path",
        ops: r
      }
    };
  }(t, e, n, function (t, e, s) {
    var i = Math.sqrt(2 * Math.PI * Math.sqrt((Math.pow(t / 2, 2) + Math.pow(e / 2, 2)) / 2)),
        n = Math.max(s.curveStepCount, s.curveStepCount / Math.sqrt(200) * i),
        o = 2 * Math.PI / n;
    var r = Math.abs(t / 2),
        h = Math.abs(e / 2);
    var c = 1 - s.curveFitting;
    return r += a(r * c, s), h += a(h * c, s), {
      increment: o,
      rx: r,
      ry: h
    };
  }(s, i, n)).opset;
}

function r(t) {
  return t.randomizer || (t.randomizer = new e(t.seed || 0)), t.randomizer.next();
}

function h(t, e, s) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  return s.roughness * i * (r(s) * (e - t) + t);
}

function a(t, e) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return h(-t, t, e, s);
}

function c(t, e, s, i, n) {
  var o = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
  var r = o ? n.disableMultiStrokeFill : n.disableMultiStroke,
      h = u(t, e, s, i, n, !0, !1);
  if (r) return h;
  var a = u(t, e, s, i, n, !0, !0);
  return h.concat(a);
}

function u(t, e, s, i, n, o, h) {
  var c = Math.pow(t - s, 2) + Math.pow(e - i, 2),
      u = Math.sqrt(c);
  var f = 1;
  f = u < 200 ? 1 : u > 500 ? .4 : -.0016668 * u + 1.233334;
  var l = n.maxRandomnessOffset || 0;
  l * l * 100 > c && (l = u / 10);
  var g = l / 2,
      d = .2 + .2 * r(n);

  var p = n.bowing * n.maxRandomnessOffset * (i - e) / 200,
      _ = n.bowing * n.maxRandomnessOffset * (t - s) / 200;

  p = a(p, n, f), _ = a(_, n, f);

  var m = [],
      w = function w() {
    return a(g, n, f);
  },
      v = function v() {
    return a(l, n, f);
  };

  return o && (h ? m.push({
    op: "move",
    data: [t + w(), e + w()]
  }) : m.push({
    op: "move",
    data: [t + a(l, n, f), e + a(l, n, f)]
  })), h ? m.push({
    op: "bcurveTo",
    data: [p + t + (s - t) * d + w(), _ + e + (i - e) * d + w(), p + t + 2 * (s - t) * d + w(), _ + e + 2 * (i - e) * d + w(), s + w(), i + w()]
  }) : m.push({
    op: "bcurveTo",
    data: [p + t + (s - t) * d + v(), _ + e + (i - e) * d + v(), p + t + 2 * (s - t) * d + v(), _ + e + 2 * (i - e) * d + v(), s + v(), i + v()]
  }), m;
}

function f(t, e, s) {
  var i = t.length,
      n = [];

  if (i > 3) {
    var _o2 = [],
        _r = 1 - s.curveTightness;

    n.push({
      op: "move",
      data: [t[1][0], t[1][1]]
    });

    for (var _e2 = 1; _e2 + 2 < i; _e2++) {
      var _s2 = t[_e2];
      _o2[0] = [_s2[0], _s2[1]], _o2[1] = [_s2[0] + (_r * t[_e2 + 1][0] - _r * t[_e2 - 1][0]) / 6, _s2[1] + (_r * t[_e2 + 1][1] - _r * t[_e2 - 1][1]) / 6], _o2[2] = [t[_e2 + 1][0] + (_r * t[_e2][0] - _r * t[_e2 + 2][0]) / 6, t[_e2 + 1][1] + (_r * t[_e2][1] - _r * t[_e2 + 2][1]) / 6], _o2[3] = [t[_e2 + 1][0], t[_e2 + 1][1]], n.push({
        op: "bcurveTo",
        data: [_o2[1][0], _o2[1][1], _o2[2][0], _o2[2][1], _o2[3][0], _o2[3][1]]
      });
    }

    if (e && 2 === e.length) {
      var _t = s.maxRandomnessOffset;
      n.push({
        op: "lineTo",
        data: [e[0] + a(_t, s), e[1] + a(_t, s)]
      });
    }
  } else 3 === i ? (n.push({
    op: "move",
    data: [t[1][0], t[1][1]]
  }), n.push({
    op: "bcurveTo",
    data: [t[1][0], t[1][1], t[2][0], t[2][1], t[2][0], t[2][1]]
  })) : 2 === i && n.push.apply(n, _toConsumableArray(c(t[0][0], t[0][1], t[1][0], t[1][1], s)));

  return n;
}

function l(t, e, s, i, n, o, r, h) {
  var c = [],
      u = [],
      f = a(.5, h) - Math.PI / 2;
  u.push([a(o, h) + e + .9 * i * Math.cos(f - t), a(o, h) + s + .9 * n * Math.sin(f - t)]);

  for (var _r2 = f; _r2 < 2 * Math.PI + f - .01; _r2 += t) {
    var _t2 = [a(o, h) + e + i * Math.cos(_r2), a(o, h) + s + n * Math.sin(_r2)];
    c.push(_t2), u.push(_t2);
  }

  return u.push([a(o, h) + e + i * Math.cos(f + 2 * Math.PI + .5 * r), a(o, h) + s + n * Math.sin(f + 2 * Math.PI + .5 * r)]), u.push([a(o, h) + e + .98 * i * Math.cos(f + r), a(o, h) + s + .98 * n * Math.sin(f + r)]), u.push([a(o, h) + e + .9 * i * Math.cos(f + .5 * r), a(o, h) + s + .9 * n * Math.sin(f + .5 * r)]), [u, c];
}

function g(t, e) {
  return {
    maxRandomnessOffset: 2,
    roughness: "highlight" === t ? 3 : 1.5,
    bowing: 1,
    stroke: "#000",
    strokeWidth: 1.5,
    curveTightness: 0,
    curveFitting: .95,
    curveStepCount: 9,
    fillStyle: "hachure",
    fillWeight: -1,
    hachureAngle: -41,
    hachureGap: -1,
    dashOffset: -1,
    dashGap: -1,
    zigzagOffset: -1,
    combineNestedSvgPaths: !1,
    disableMultiStroke: "double" !== t,
    disableMultiStrokeFill: !1,
    seed: e
  };
}

function d(e, r, h, a, c, u) {
  var f = [];
  var l = h.strokeWidth || 2;

  var d = function (t) {
    var e = t.padding;

    if (e || 0 === e) {
      if ("number" == typeof e) return [e, e, e, e];

      if (Array.isArray(e)) {
        var _t3 = e;
        if (_t3.length) switch (_t3.length) {
          case 4:
            return _toConsumableArray(_t3);

          case 1:
            return [_t3[0], _t3[0], _t3[0], _t3[0]];

          case 2:
            return [].concat(_toConsumableArray(_t3), _toConsumableArray(_t3));

          case 3:
            return [].concat(_toConsumableArray(_t3), [_t3[1]]);

          default:
            return [_t3[0], _t3[1], _t3[2], _t3[3]];
        }
      }
    }

    return [5, 5, 5, 5];
  }(h),
      p = void 0 === h.animate || !!h.animate,
      _ = h.iterations || 2,
      m = g("single", u);

  switch (h.type) {
    case "underline":
      {
        var _t4 = r.y + r.h + d[2];

        for (var _e3 = 0; _e3 < _; _e3++) {
          _e3 % 2 ? f.push(s(r.x + r.w, _t4, r.x, _t4, m)) : f.push(s(r.x, _t4, r.x + r.w, _t4, m));
        }

        break;
      }

    case "strike-through":
      {
        var _t5 = r.y + r.h / 2;

        for (var _e4 = 0; _e4 < _; _e4++) {
          _e4 % 2 ? f.push(s(r.x + r.w, _t5, r.x, _t5, m)) : f.push(s(r.x, _t5, r.x + r.w, _t5, m));
        }

        break;
      }

    case "box":
      {
        var _t6 = r.x - d[3],
            _e5 = r.y - d[0],
            _s3 = r.w + (d[1] + d[3]),
            _i = r.h + (d[0] + d[2]);

        for (var _o3 = 0; _o3 < _; _o3++) {
          f.push(n(_t6, _e5, _s3, _i, m));
        }

        break;
      }

    case "bracket":
      {
        var _t7 = Array.isArray(h.brackets) ? h.brackets : h.brackets ? [h.brackets] : ["right"],
            _e6 = r.x - 2 * d[3],
            _s4 = r.x + r.w + 2 * d[1],
            _n2 = r.y - 2 * d[0],
            _o4 = r.y + r.h + 2 * d[2];

        var _iterator = _createForOfIteratorHelper(_t7),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _h = _step.value;

            var _t8 = void 0;

            switch (_h) {
              case "bottom":
                _t8 = [[_e6, r.y + r.h], [_e6, _o4], [_s4, _o4], [_s4, r.y + r.h]];
                break;

              case "top":
                _t8 = [[_e6, r.y], [_e6, _n2], [_s4, _n2], [_s4, r.y]];
                break;

              case "left":
                _t8 = [[r.x, _n2], [_e6, _n2], [_e6, _o4], [r.x, _o4]];
                break;

              case "right":
                _t8 = [[r.x + r.w, _n2], [_s4, _n2], [_s4, _o4], [r.x + r.w, _o4]];
            }

            _t8 && f.push(i(_t8, !1, m));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        break;
      }

    case "crossed-off":
      {
        var _t9 = r.x,
            _e7 = r.y,
            _i2 = _t9 + r.w,
            _n3 = _e7 + r.h;

        for (var _o5 = 0; _o5 < _; _o5++) {
          _o5 % 2 ? f.push(s(_i2, _n3, _t9, _e7, m)) : f.push(s(_t9, _e7, _i2, _n3, m));
        }

        for (var _o6 = 0; _o6 < _; _o6++) {
          _o6 % 2 ? f.push(s(_t9, _n3, _i2, _e7, m)) : f.push(s(_i2, _e7, _t9, _n3, m));
        }

        break;
      }

    case "circle":
      {
        var _t10 = g("double", u),
            _e8 = r.w + (d[1] + d[3]),
            _s5 = r.h + (d[0] + d[2]),
            _i3 = r.x - d[3] + _e8 / 2,
            _n4 = r.y - d[0] + _s5 / 2,
            _h2 = Math.floor(_ / 2),
            _a = _ - 2 * _h2;

        for (var _r3 = 0; _r3 < _h2; _r3++) {
          f.push(o(_i3, _n4, _e8, _s5, _t10));
        }

        for (var _t11 = 0; _t11 < _a; _t11++) {
          f.push(o(_i3, _n4, _e8, _s5, m));
        }

        break;
      }

    case "highlight":
      {
        var _t12 = g("highlight", u);

        l = .95 * r.h;

        var _e9 = r.y + r.h / 2;

        for (var _i4 = 0; _i4 < _; _i4++) {
          _i4 % 2 ? f.push(s(r.x + r.w, _e9, r.x, _e9, _t12)) : f.push(s(r.x, _e9, r.x + r.w, _e9, _t12));
        }

        break;
      }
  }

  if (f.length) {
    var _s6 = function (t) {
      var e = [];

      var _iterator2 = _createForOfIteratorHelper(t),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _s7 = _step2.value;
          var _t13 = "";

          var _iterator3 = _createForOfIteratorHelper(_s7.ops),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _i6 = _step3.value;
              var _s8 = _i6.data;

              switch (_i6.op) {
                case "move":
                  _t13.trim() && e.push(_t13.trim()), _t13 = "M".concat(_s8[0], " ").concat(_s8[1], " ");
                  break;

                case "bcurveTo":
                  _t13 += "C".concat(_s8[0], " ").concat(_s8[1], ", ").concat(_s8[2], " ").concat(_s8[3], ", ").concat(_s8[4], " ").concat(_s8[5], " ");
                  break;

                case "lineTo":
                  _t13 += "L".concat(_s8[0], " ").concat(_s8[1], " ");
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          _t13.trim() && e.push(_t13.trim());
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return e;
    }(f),
        _i5 = [],
        _n5 = [];

    var _o7 = 0;

    var _r4 = function _r4(t, e, s) {
      return t.setAttribute(e, s);
    };

    var _iterator4 = _createForOfIteratorHelper(_s6),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _a2 = _step4.value;

        var _s10 = document.createElementNS(t, "path");

        if (_r4(_s10, "d", _a2), _r4(_s10, "fill", "none"), _r4(_s10, "stroke", h.color || "currentColor"), _r4(_s10, "stroke-width", "" + l), p) {
          var _t15 = _s10.getTotalLength();

          _i5.push(_t15), _o7 += _t15;
        }

        e.appendChild(_s10), _n5.push(_s10);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    if (p) {
      var _t14 = 0;

      for (var _e10 = 0; _e10 < _n5.length; _e10++) {
        var _s9 = _n5[_e10],
            _r5 = _i5[_e10],
            _h3 = _o7 ? c * (_r5 / _o7) : 0,
            _u = a + _t14,
            _f = _s9.style;

        _f.strokeDashoffset = "" + _r5, _f.strokeDasharray = "" + _r5, _f.animation = "rough-notation-dash ".concat(_h3, "ms ease-out ").concat(_u, "ms forwards"), _t14 += _h3;
      }
    }
  }
}

var p = /*#__PURE__*/function () {
  function p(t, e) {
    var _this = this;

    _classCallCheck(this, p);

    this._state = "unattached", this._resizing = !1, this._seed = Math.floor(Math.random() * Math.pow(2, 31)), this._lastSizes = [], this._animationDelay = 0, this._resizeListener = function () {
      _this._resizing || (_this._resizing = !0, setTimeout(function () {
        _this._resizing = !1, "showing" === _this._state && _this.haveRectsChanged() && _this.show();
      }, 400));
    }, this._e = t, this._config = JSON.parse(JSON.stringify(e)), this.attach();
  }

  _createClass(p, [{
    key: "attach",
    value: function attach() {
      if ("unattached" === this._state && this._e.parentElement) {
        !function () {
          if (!window.__rno_kf_s) {
            var _t16 = window.__rno_kf_s = document.createElement("style");

            _t16.textContent = "@keyframes rough-notation-dash { to { stroke-dashoffset: 0; } }", document.head.appendChild(_t16);
          }
        }();

        var _e11 = this._svg = document.createElementNS(t, "svg");

        _e11.setAttribute("class", "rough-annotation");

        var _s11 = _e11.style;
        _s11.position = "absolute", _s11.top = "0", _s11.left = "0", _s11.overflow = "visible", _s11.pointerEvents = "none", _s11.width = "100px", _s11.height = "100px";

        var _i7 = "highlight" === this._config.type;

        if (this._e.insertAdjacentElement(_i7 ? "beforebegin" : "afterend", _e11), this._state = "not-showing", _i7) {
          var _t17 = window.getComputedStyle(this._e).position;
          (!_t17 || "static" === _t17) && (this._e.style.position = "relative");
        }

        this.attachListeners();
      }
    }
  }, {
    key: "detachListeners",
    value: function detachListeners() {
      window.removeEventListener("resize", this._resizeListener), this._ro && this._ro.unobserve(this._e);
    }
  }, {
    key: "attachListeners",
    value: function attachListeners() {
      var _this2 = this;

      this.detachListeners(), window.addEventListener("resize", this._resizeListener, {
        passive: !0
      }), !this._ro && "ResizeObserver" in window && (this._ro = new window.ResizeObserver(function (t) {
        var _iterator5 = _createForOfIteratorHelper(t),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _e12 = _step5.value;
            _e12.contentRect && _this2._resizeListener();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      })), this._ro && this._ro.observe(this._e);
    }
  }, {
    key: "haveRectsChanged",
    value: function haveRectsChanged() {
      if (this._lastSizes.length) {
        var _t18 = this.rects();

        if (_t18.length !== this._lastSizes.length) return !0;

        for (var _e13 = 0; _e13 < _t18.length; _e13++) {
          if (!this.isSameRect(_t18[_e13], this._lastSizes[_e13])) return !0;
        }
      }

      return !1;
    }
  }, {
    key: "isSameRect",
    value: function isSameRect(t, e) {
      var s = function s(t, e) {
        return Math.round(t) === Math.round(e);
      };

      return s(t.x, e.x) && s(t.y, e.y) && s(t.w, e.w) && s(t.h, e.h);
    }
  }, {
    key: "isShowing",
    value: function isShowing() {
      return "not-showing" !== this._state;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this3 = this;

      this.isShowing() && !this.pendingRefresh && (this.pendingRefresh = Promise.resolve().then(function () {
        _this3.isShowing() && _this3.show(), delete _this3.pendingRefresh;
      }));
    }
  }, {
    key: "show",
    value: function show() {
      switch (this._state) {
        case "unattached":
          break;

        case "showing":
          this.hide(), this._svg && this.render(this._svg, !0);
          break;

        case "not-showing":
          this.attach(), this._svg && this.render(this._svg, !1);
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this._svg) for (; this._svg.lastChild;) {
        this._svg.removeChild(this._svg.lastChild);
      }
      this._state = "not-showing";
    }
  }, {
    key: "remove",
    value: function remove() {
      this._svg && this._svg.parentElement && this._svg.parentElement.removeChild(this._svg), this._svg = void 0, this._state = "unattached", this.detachListeners();
    }
  }, {
    key: "render",
    value: function render(t, e) {
      var s = this._config;
      e && (s = JSON.parse(JSON.stringify(this._config)), s.animate = !1);
      var i = this.rects();
      var n = 0;
      i.forEach(function (t) {
        return n += t.w;
      });
      var o = s.animationDuration || 800;
      var r = 0;

      for (var _e14 = 0; _e14 < i.length; _e14++) {
        var _h4 = o * (i[_e14].w / n);

        d(t, i[_e14], s, r + this._animationDelay, _h4, this._seed), r += _h4;
      }

      this._lastSizes = i, this._state = "showing";
    }
  }, {
    key: "rects",
    value: function rects() {
      var t = [];
      if (this._svg) if (this._config.multiline) {
        var _e15 = this._e.getClientRects();

        for (var _s12 = 0; _s12 < _e15.length; _s12++) {
          t.push(this.svgRect(this._svg, _e15[_s12]));
        }
      } else t.push(this.svgRect(this._svg, this._e.getBoundingClientRect()));
      return t;
    }
  }, {
    key: "svgRect",
    value: function svgRect(t, e) {
      var s = t.getBoundingClientRect(),
          i = e;
      return {
        x: (i.x || i.left) - (s.x || s.left),
        y: (i.y || i.top) - (s.y || s.top),
        w: i.width,
        h: i.height
      };
    }
  }, {
    key: "animate",
    get: function get() {
      return this._config.animate;
    },
    set: function set(t) {
      this._config.animate = t;
    }
  }, {
    key: "animationDuration",
    get: function get() {
      return this._config.animationDuration;
    },
    set: function set(t) {
      this._config.animationDuration = t;
    }
  }, {
    key: "iterations",
    get: function get() {
      return this._config.iterations;
    },
    set: function set(t) {
      this._config.iterations = t;
    }
  }, {
    key: "color",
    get: function get() {
      return this._config.color;
    },
    set: function set(t) {
      this._config.color !== t && (this._config.color = t, this.refresh());
    }
  }, {
    key: "strokeWidth",
    get: function get() {
      return this._config.strokeWidth;
    },
    set: function set(t) {
      this._config.strokeWidth !== t && (this._config.strokeWidth = t, this.refresh());
    }
  }, {
    key: "padding",
    get: function get() {
      return this._config.padding;
    },
    set: function set(t) {
      this._config.padding !== t && (this._config.padding = t, this.refresh());
    }
  }]);

  return p;
}();

function _(t, e) {
  return new p(t, e);
}

function m(t) {
  var e = 0;

  var _iterator6 = _createForOfIteratorHelper(t),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _s13 = _step6.value;
      var _t21 = _s13;
      _t21._animationDelay = e;
      e += 0 === _t21.animationDuration ? 0 : _t21.animationDuration || 800;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  var s = _toConsumableArray(t);

  return {
    show: function show() {
      var _iterator7 = _createForOfIteratorHelper(s),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _t19 = _step7.value;

          _t19.show();
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    },
    hide: function hide() {
      var _iterator8 = _createForOfIteratorHelper(s),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _t20 = _step8.value;

          _t20.hide();
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  };
}

export { _ as annotate, m as annotationGroup };